import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { StyledTextField } from "../../../common/components/TextField/styles";
import DateInput from "../../../common/components/Input";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { addPaymentTransactionThruEmailSchema } from "../schema/addPaymentTransactionThruEmailSchema";
import { Autocomplete } from "@mui/material";
import { addPaymentTransaction } from "../../../api/caseApi";
import { sendPaymentEmailWithCustomAmount } from "../../../api/caseApi";
const AddPaymentTransactionThruEmailDialog = ({
  openAddPaymentTransaction,
  handleCloseAddPaymentTransaction,
  getPaymentTransactions,
  caseDetails,
}) => {
  const [types, setTypes] = useState([]);
  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(addPaymentTransactionThruEmailSchema),
  });

  const amount = watch("amount");
  const caseProgressId = watch("caseProgressId");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modeOfPayment, setModeOfPayment] = useState(null);
  const [currentCaseProgress, setCurrentCaseProgress] = useState(null);
  console.log(caseDetails);
  useEffect(() => {
    let defaultValues = {};
    defaultValues.caseId = caseDetails.id;
    reset({ ...defaultValues });
    let designCount = 0,
      setCount = 0;
    setTypes([]);
    caseDetails.caseProgressions.forEach((cp) => {
      if (cp.type === "F2F Consultation") {
        let type = { name: "F2F Consultation Payment", caseProgressId: cp.id };
        setTypes((prev) => [...prev, type]);
      } else if (cp.type === "Scanning") {
        let type = { name: "Scanning Payment", caseProgressId: cp.id };
        setTypes((prev) => [...prev, type]);
      } else if (cp.type === "Design") {
        if (designCount === 0) {
          let type = { name: "Design Payment", caseProgressId: cp.id };
          setTypes((prev) => [...prev, type]);
          designCount++;
        }
      }
      // else if (cp.type === "Set" && cp.isPaid === false) {
      //   if (setCount === 0) {
      //     let type = { name: "Set Payment", caseProgressId: cp.id };
      //     setTypes((prev) => [...prev, type]);
      //     setCount++;
      //   }
      // }
    });
  }, [caseDetails]);

  const submitPaymentEmailWithCustomAmount = async (values) => {
    setIsSubmitting(true);
    const response = await sendPaymentEmailWithCustomAmount(
      modeOfPayment,
      values.caseProgressId,
      values.amount,
    );
    handleCloseAddPaymentTransaction();
    getPaymentTransactions();
    setIsSubmitting(false);
    reset();
  };

  const handleSetCaseProgress = (id) => {
    caseDetails.caseProgressions.forEach((cp) => {
      if (cp.id === id) {
        setCurrentCaseProgress(cp);
      }
    });
  };
  return (
    <div>
      <StyledDialog
        open={openAddPaymentTransaction}
        onClose={() => {
          handleCloseAddPaymentTransaction();
          reset();
        }}
        fullWidth
        maxWidth="md"
        width="900px"
      >
        <DialogTitle>Send Payment Email with Custom Amount</DialogTitle>
        <form onSubmit={handleSubmit(submitPaymentEmailWithCustomAmount)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={6.5}>
                <Controller
                  control={control}
                  name="caseProgressId"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <Autocomplete
                      options={types}
                      onChange={(_, val) => {
                        onChange(val?.caseProgressId || "");
                        handleSetCaseProgress(val?.caseProgressId);
                  
                      }}
                      getOptionLabel={(option) => option.name || option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(error)}
                          label={"Payment Type"}
                          FormHelperTextProps={{ variant: "standard" }}
                          helperText={error && error.message}
                        />
                      )}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.caseProgressId}>
                            {option.name}
                          </li>
                        );
                      }}
                      sx={{ width: "100%", paddingBottom: "20px" }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6.5}>
                <StyledTextField
                  sx={{ width: "100%" }}
                  variant="outlined"
                  label="Amount"
                  InputProps={{ inputProps: { step: "any" } }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.amount}
                  helperText={errors.amount?.message}
                  {...register("amount")}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseAddPaymentTransaction}
              style={{ marginRight: "10px" }}
            >
              Cancel
            </StyledButton>
            {/* {caseProgressId && amount && (
              <Grid item xs={12}>
                <StyledButton
                  type="submit"
                  theme="green"
                  onClick={() => setModeOfPayment("PayPal")}
                  disabled={isSubmitting}
                >
                  Send PayPal Payment Email
                </StyledButton>
              </Grid>
            )}
            {caseProgressId && amount && (
              <Grid item xs={12}>
                <StyledButton
                  type="submit"
                  theme="green"
                  disabled={isSubmitting}
                  onClick={() => setModeOfPayment("GCash")}
                >
                  Send GCash Payment Email
                </StyledButton>
              </Grid>
            )} */}

            {caseProgressId && amount && (
              <Grid item xs={12}>
                <StyledButton
                  type="submit"
                  theme="green"
                  disabled={isSubmitting}
                  onClick={() => setModeOfPayment("Xendit")}
                >
                  Send Xendit Payment Email
                </StyledButton>
              </Grid>
            )}
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddPaymentTransactionThruEmailDialog;
